export default function SubscriptionFree({className}) {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="458" height="458" viewBox="0 0 458 458" class={`MuiSvgIcon-root ${className}`}>
      <defs>
        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0" stop-color="#0060f9"/>
          <stop offset="1" stop-color="#75a8fb"/>
        </linearGradient>
        <clipPath id="clip-Free">
          <rect width="458" height="458"/>
        </clipPath>
      </defs>
      <g id="Free" clip-path="url(#clip-Free)">
        <g id="Groupe_5986" data-name="Groupe 5986" transform="translate(16460.875 -15490.402)">
          <path id="visibility_FILL1_wght400_GRAD0_opsz24" d="M215.124-637.612a41.453,41.453,0,0,1-30.448-12.537A41.453,41.453,0,0,1,172.139-680.6a41.453,41.453,0,0,1,12.537-30.448,41.453,41.453,0,0,1,30.448-12.537,41.453,41.453,0,0,1,30.448,12.537A41.453,41.453,0,0,1,258.109-680.6a41.453,41.453,0,0,1-12.537,30.448A41.453,41.453,0,0,1,215.124-637.612Z" transform="translate(-16447 16400)" fill="#75a8fb"/>
          <path id="visibility_FILL1_wght400_GRAD0_opsz24-2" data-name="visibility_FILL1_wght400_GRAD0_opsz24" d="M215.124-608.956q29.851,0,50.746-20.9t20.9-50.746q0-29.851-20.9-50.746t-50.746-20.9q-29.851,0-50.746,20.9t-20.9,50.746q0,29.851,20.9,50.746T215.124-608.956Zm0,47.761q-58.109,0-105.87-32.438T40-680.6q21.492-54.527,69.254-86.965T215.124-800q58.109,0,105.87,32.438T390.248-680.6q-21.493,54.527-69.254,86.965T215.124-561.195Z" transform="translate(-16447 16400)" fill="url(#linear-gradient)"/>
        </g>
      </g>
    </svg>
  )}
  

